import ApiService from './api.service'

const ReferencesService = {
	getReferences:  function () {
		return  ApiService.get('/references/parents');
	},
	getReferenceChildren:  function (parentCode) {
		return  ApiService.get(`/references/${parentCode}/list`);
	},
	getSearchExpenses(payload) {
		let value = '';
		if (payload.value) {value = payload.value}
		let data = {
			departmentId: payload.departmentId?payload.departmentId.id:null,
			expenseDate: payload.expenseDate
		}
		return ApiService.post(`daily-expanse/get-expanses?page=${payload.page}&limit=${payload.limit}&value=${value}`, data)
	},
	getSearchExpenses1(payload) {
		let value = '';
		if (payload.value) {
			value = payload.value
		}
		return ApiService.post(`daily-expanse-type/get-expanse-types?page=${payload.page}&limit=${payload.limit}&value=${value}`)
	},
	getSearchExpenses2(value) {
		return ApiService.post(`daily-expanse-type/get-expanse-types/${value}`)
	},
	getReferenceChildrencreate:  function (data) {
		return  ApiService.post(`/daily-expanse/create`, data);
	},
	getReferenceChildrencreate1:  function (data) {
		return  ApiService.post(`/daily-expanse-type/create`, data);
	},
	getCategorysByGroupIds(groupIds) {
		return ApiService.post('/references/category-by-groupIds', groupIds)
	},
	getSubReferenceChildren:  function (parentId) {
		return  ApiService.get(`/references/${parentId}/children`);
	},
	deleteRef:  function (refId) {
		return  ApiService.delete(`/references/delete/${refId}`);
	},
	updateOrCreateRefParentById:  function (payload) {
		return  ApiService.post('/references/parent', payload);
	},
	updateOrCreateRefChildById:  function (payload) {
		return  ApiService.post('/references/child', payload);
	},
	stroreChild(parent,data) {
		return ApiService.post(`/references/create-child/${parent}`, data)
	},
	getPaymentMethods: function() {
		return ApiService.get(`/references/payment_type/list`)
	},
	getMxikCodeList(keyword) {
		return ApiService.get(`/mxik-code/search-by-keyword?keyword=${keyword}`)
	},
	getByMxikId(id) {
		return ApiService.get(`/mxik-code/get-mxik-code/${id}`)
	},
	upLoudExcel: async function (form) {
		let bodyFormData = new FormData();
		bodyFormData.append('upload', form)
		var requestData = {
			method: 'post',
			url: `/pricing/check-has-item`,
			data: bodyFormData,
			headers: {'Content-Type': 'multipart/form-data'}
		};
		try {
			return await ApiService.customRequest(requestData);

		} catch (error) {
			return error.response.data
		}
	},
};

export default ReferencesService
